import { faUser, faTimes } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { Button, Modal, FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Breakpoints } from '@b-stock/fe-core/design-system'
import { designColors } from '@b-stock/fe-core/theme'

import { redirectToAuth, redirectSignUp } from '@/helpers/auth'

interface IProps {
  closeUnAuthModal: () => void
  reason: string
}

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    margin: 0;
  }
  @media ${Breakpoints.min.large} {
    width: 43.75rem;
  }
`

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4rem;
  height: 4rem;
  color: ${designColors.neutral.veryDarkGray};
  border: 0.0625rem solid ${designColors.neutral.mediumGray};
  border-radius: 50%;
  font-size: 2rem;
`

const CloseIcon = styled(FontAwesomeIcon)`
  position: absolute;
  right: 0;
  top: 0;
  font-size: 1.5rem;
  cursor: pointer;
  color: ${designColors.neutral.darkGray};
`

const StyledText = styled.p`
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 700;
  color: ${designColors.neutral.black};
  && {
    margin-top: 1.5rem;
  }
`

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 3rem;
  @media (max-width: 786px) {
    justify-content: space-between;
    margin-top: 2rem;
  }
`

export const UnAuthWarningModal = ({ closeUnAuthModal, reason }: IProps) => (
  <Modal closeModal={closeUnAuthModal}>
    <Modal.Content>
      <Container>
        <CloseIcon icon={faTimes} onClick={closeUnAuthModal} />
        <IconWrapper>
          <FontAwesomeIcon icon={faUser} />
        </IconWrapper>
        <StyledText>
          <FormattedMessage
            id="Common.unAuthModal.description"
            values={{ reason }}
          />
        </StyledText>
        <Actions>
          <Button onClick={redirectToAuth} size="medium" appearance="secondary">
            <FormattedMessage id="Common.signIn" />
          </Button>
          <Button onClick={redirectSignUp} size="medium" appearance="primary">
            <FormattedMessage id="Common.register" />
          </Button>
        </Actions>
      </Container>
    </Modal.Content>
  </Modal>
)
